export default __webpack_public_path__ + "static/media/firstup.74889014535b70413f12384e7ae8df74.svg";